/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { AdSlotRow } from "../collection-templates/ad-slot-row";
import { CustomWidgetRow } from "../collection-templates/custom-widget-row";

const StoryRowWrapper = ({ rows, children }) => {
  if (!rows.length) {
    rows = [
      {
        rowId: 1603877816292,
        type: "story",
        config: {},
        pageType: "story"
      }
    ];
  }

  return rows.map(row => {
    switch (row.type) {
      case "widget":
        return <CustomWidgetRow metadata={row} key={row.rowId} />;
      case "ads":
        return <AdSlotRow metadata={row} key={row.rowId} />;
      case "story":
        return children;
    }
  });
};

export default StoryRowWrapper;
